interface Logout {
	color?: string;
}

const LogoutIcon: React.FC<Logout> = ({ color }) => {
	return (
		<svg width="24" height="24" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill={color || "#212121"}
				d="M8.9181 4L7.5308 5.4L10.1072 8H-0.000244141V10H10.1072L7.5308 12.6L8.9181 14L13.8727 9L8.9181 4ZM17.8364 16H9.90903V18H17.8364C18.9265 18 19.8183 17.1 19.8183 16V2C19.8183 0.9 18.9265 0 17.8364 0H9.90903V2H17.8364V16Z"
			/>
		</svg>
	);
};

export default LogoutIcon;
